import { useFonts } from 'expo-font'
import { Slot } from 'expo-router'
import type { ReactNode } from 'react'

export const AnimatedSplashScreen = ({ children }: { children: ReactNode }) => {
	const [fontsLoaded, fontError] = useFonts({
		'Apercu-Bold': require('#/assets/fonts/Apercu-Bold.ttf'),
		'Apercu-Light': require('#/assets/fonts/Apercu-Light.ttf'),
		'Apercu-Medium': require('#/assets/fonts/Apercu-Medium.ttf'),
	})

	if (!fontsLoaded && !fontError) {
		return <Slot />
	}

	return children
}
